var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCircleCheck = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30c8.285 0 15-6.715 15-15S23.285 0 15 0 0 6.715 0 15s6.715 15 15 15zm6.621-17.754-7.5 7.5a1.4 1.4 0 0 1-1.986 0l-3.75-3.75a1.406 1.406 0 0 1 1.986-1.986l2.754 2.754 6.504-6.51a1.406 1.406 0 0 1 1.986 1.986l.006.006z",
    fill: "#3E704B",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle-check.7be3c1b5.svg";
export { ForwardRef as ReactComponent };